import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import Home from "./pages/Home";
import { HelmetProvider } from "react-helmet-async";
import Contact from "./pages/Contact";
import About from "./pages/About";
import Document1 from "./pages/Document1";
import Document2 from "./pages/Document2";
import Document3 from "./pages/Document3";
import K1MulczerLesny from "./pages/offer/K1MulczerLesny";
import K1KarczowanieDrzew from "./pages/offer/K1KarczowanieDrzew";
import K1FrezowaniePni from "./pages/offer/K1FrezowaniePni";
import K1NiwelacjaTerenu from "./pages/offer/K1NiwelacjaTerenu";
import K1PrzygotowanieDokumentacji from "./pages/offer/K1PrzygotowanieDokumentacji";
import K2CzyszczenieDzialek from "./pages/offer/K2CzyszczenieDzialek";
import K2PraceZiemne from "./pages/offer/K2PraceZiemne";
import K2RownanieTerenu from "./pages/offer/K2RownanieTerenu";
import K2WycinkaDrzew from "./pages/offer/K2WycinkaDrzew";
import K3Nawodnienie from "./pages/offer/K3Nawodnienie";
import K3NiwelacjaTerenu from "./pages/offer/K3NiwelacjaTerenu";
import K3PraceZiemne from "./pages/offer/K3PraceZiemne";
import K3Projektowanie from "./pages/offer/K3Projektowanie";
import K3TrawaRolka from "./pages/offer/K3TrawaRolka";
import K3TrawaSiew from "./pages/offer/K3TrawaSiew";
import K3UslugaGlebogryzarki from "./pages/offer/K3UslugaGlebogryzarki";
import K3ZakladanieOgrodu from "./pages/offer/K3ZakladanieOgrodu";
import K4Ogrodzenia from "./pages/offer/K4Ogrodzenia";
import K1Ekspertyzy from "./pages/offer/K1Ekspertyzy";
import K1WycinkaKlasyczna from "./pages/offer/K1WycinkaKlasyczna";
import K1WycinkaAlpinistyczna from "./pages/offer/K1WycinkaAlpinistyczna";
import HomeSeo from "./pages/HomeSeo";
import Faq from "./pages/faq";
import KnowledgeBase from "./pages/KnowledgeBase";
import SinglePost from "./pages/SinglePost";

const cities = [
  "Wejherowo",
  "Kartuzy",
  "Chmielno",
  "Przodkowo",
  "Sierakowice",
  "Somonino",
  "Stężyca",
  "Sulęczyno",
  "Gdańsk",
  "Kosakowo",
  "Krokowa",
  "Puck",
  "Lębork",
  "Słupsk",
  "Tczew",
  "Pruszcz Gdański",
  "Przywidz",
  "Żukowo",
  "Łeba",
  "Władysławowo",
  "Skarszewy",
  "Sztum",
  "Bolszewo",
  "Orle",
  "Luzino",
];

function App() {
  const helmetContext = {};

  return (
    <HelmetProvider context={helmetContext}>
      <div className="App">
        <BrowserRouter>
          <Routes>
            {/* MAIN */}
            <Route path="/" element={<Home />} />
            {cities.map((city) => (
              <Route
                key={city}
                path={`/${city.toLowerCase().replaceAll(" ", "-")}`}
                element={<HomeSeo city={city} />}
              />
            ))}
            <Route path="/kontakt" element={<Contact />} />
            <Route path="/o-nas" element={<About />} />
            {/* OFFER - KAT 1 */}
            <Route
              path="/oczyszczanie-terenu/mulczer-lesny"
              element={<K1MulczerLesny />}
            />
            <Route
              path="/oczyszczanie-terenu/karczowanie-drzew"
              element={<K1KarczowanieDrzew />}
            />
            <Route
              path="/oczyszczanie-terenu/frezowanie-pni"
              element={<K1FrezowaniePni />}
            />
            <Route
              path="/oczyszczanie-terenu/niewelacja-terenu"
              element={<K1NiwelacjaTerenu />}
            />
            <Route
              path="/oczyszczanie-terenu/prace-ziemne"
              element={<K2PraceZiemne />}
            />
            <Route
              path="/oczyszczanie-terenu/przygotowanie-dokumentacji"
              element={<K1PrzygotowanieDokumentacji />}
            />
            <Route
              path="/oczyszczanie-terenu/ekspertyzy"
              element={<K1Ekspertyzy />}
            />
            <Route
              path="/oczyszczanie-terenu/wycinka-klasyczna"
              element={<K1WycinkaKlasyczna />}
            />
            <Route
              path="/oczyszczanie-terenu/wycinka-alpinistyczna"
              element={<K1WycinkaAlpinistyczna />}
            />
            {/* OFFER - KAT 2 */}
            <Route path="/prace-ziemne/" element={<K2PraceZiemne />} />
            <Route
              path="/prace-ziemne/rownanie-terenu"
              element={<K2RownanieTerenu />}
            />
            <Route
              path="/prace-ziemne/czyszczenie-dzialek"
              element={<K2CzyszczenieDzialek />}
            />
            <Route
              path="/prace-ziemne/wycinka-drzew"
              element={<K2WycinkaDrzew />}
            />
            {/* OFFER - KAT 3 */}
            <Route
              path="/zakladanie-ogrodu/projektowanie"
              element={<K3Projektowanie />}
            />
            <Route
              path="/zakladanie-ogrodu/"
              element={<K3ZakladanieOgrodu />}
            />
            <Route
              path="/zakladanie-ogrodu/niwelacja-terenu"
              element={<K3NiwelacjaTerenu />}
            />
            <Route
              path="/zakladanie-ogrodu/prace-ziemne"
              element={<K3PraceZiemne />}
            />
            <Route
              path="/zakladanie-ogrodu/nawodnienie"
              element={<K3Nawodnienie />}
            />
            <Route
              path="/zakladanie-ogrodu/trawa-z-rolki"
              element={<K3TrawaRolka />}
            />
            <Route
              path="/zakladanie-ogrodu/trawa-z-siewu"
              element={<K3TrawaSiew />}
            />
             <Route
              path="faq"
              element={<Faq />}
            />
            <Route
              path="/zakladanie-ogrodu/usluga-glebogryzarki"
              element={<K3UslugaGlebogryzarki />}
            />
            {/* OFFER - KAT 4 */}

        
        

          <Route path="/baza-wiedzy" element={<KnowledgeBase />} />
          <Route path="/baza-wiedzy/:slug" element={<SinglePost />} />

            <Route path="/ogrodzenia/" element={<K4Ogrodzenia />} />
            {/* DOCUMENTS */}
            <Route path="/regulamin-serwisu" element={<Document1 />} />
            <Route path="/polityka-prywatnosci" element={<Document2 />} />
            <Route path="/obowiazek-informacyjny" element={<Document3 />} />
          </Routes>
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
